"use client"

import { createContext, useCallback, useContext, useMemo } from "react"

import { asRoute } from "@/lib/routes"
import { storefrontNavigationHref } from "@/platform/app-mode/navigation-path"

const NavigationContext = createContext<{ isApp: boolean; origin?: string }>({ isApp: false })

export const NavigationProvider = ({ isApp, origin, children }: { isApp: boolean; origin?: string; children: React.ReactNode }) => {
  const value = useMemo(() => ({ isApp, origin }), [isApp, origin])
  return <NavigationContext.Provider value={value}>{children}</NavigationContext.Provider>
}

export const useIsAppNavigation = () => useContext(NavigationContext).isApp

export const useNavigationPath = () => {
  const { isApp, origin } = useContext(NavigationContext)
  return useCallback((path: string) => asRoute(storefrontNavigationHref(path, isApp, origin)), [isApp, origin])
}
